import { render, staticRenderFns } from "./safetyOrgChart.vue?vue&type=template&id=2b468c94&scoped=true"
import script from "./safetyOrgChart.vue?vue&type=script&lang=js"
export * from "./safetyOrgChart.vue?vue&type=script&lang=js"
import style0 from "./safetyOrgChart.vue?vue&type=style&index=0&id=2b468c94&lang=sass"
import style1 from "./safetyOrgChart.vue?vue&type=style&index=1&id=2b468c94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b468c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b468c94')) {
      api.createRecord('2b468c94', component.options)
    } else {
      api.reload('2b468c94', component.options)
    }
    module.hot.accept("./safetyOrgChart.vue?vue&type=template&id=2b468c94&scoped=true", function () {
      api.rerender('2b468c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/org/safetyOrgChart.vue"
export default component.exports